import React from 'react';
import PropTypes from 'prop-types';
//import Chart from 'react-apexcharts'
import classNames from 'classnames';

import { calculateMark } from '../../utils/mark';
//import { formatCounter } from '../../utils/formatting';

import styles from './Voting.module.css';

export const VOTING_TOTAL_LABEL = `Голосов пользователей`;
export const VOTING_VOTE_LABEL = `Рейтинг мода`;


export default class Voting extends React.PureComponent {
    static propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
        mark: PropTypes.number.isRequired,
        vote: PropTypes.number.isRequired,
        userVote: PropTypes.number,
        onVoteAction: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            value: 0,
        }
    }

    componentDidMount() {
        this.setState({
            value: this.props.userVote || 0,
        })
    }

    handleDislikeClick = () => {
        if (!this.props.isAuthenticated) {
            return
        }

        const value = this.state.value === -1 ? 0 : -1
        this.setState({ value })
        this.props.onVoteAction(value)
    }

    handleLikeClick = () => {
        if (!this.props.isAuthenticated) {
            return
        }

        const value = this.state.value === 1 ? 0 : 1
        this.setState({ value })
        this.props.onVoteAction(value)
    }

    render() {
        /*const options = {
            plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 135,
                    track: {
                        background: '#272729',
                    },
                    hollow: {
                        size: '78%',
                    },
                    dataLabels: {
                        show: false,
                    },
                },
            },
            fill: {
                type: 'image',
                image: {
                    src: ['data:image/jpeg;base64,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'],
                },
            },
        }*/

        const mark = calculateMark(this.props.mark).mark
        //const percent = calculateMark(this.props.mark).percent

        const classNameBase = classNames(styles.base, {
            [styles.isEmpty]: !this.props.mark,
        })

        const classNameButtonLike = classNames(styles.button, styles.button__like, {
            [styles.isActive]: this.state.value === 1,
            [styles.isDisabled]: !this.props.isAuthenticated,
            //[styles['ev_click-rate-mod']]: true,
        })

        const classNameButtonDislike = classNames(styles.button, styles.button__dislike, {
            [styles.isActive]: this.state.value === -1,
            [styles.isDisabled]: !this.props.isAuthenticated,
            //[styles['ev_click-rate-mod']]: true,
        })

        return (
            <div className={classNameBase}>
                {/* <div className="Voting_body">
                    <div className="Voting_progress" />
                    <div className="Voting_chart">
                        <Chart
                            options={options}
                            series={[percent]}
                            type="radialBar"
                            width={265}
                            height={265}
                        />
                    </div>
                    <div className="Voting_rating">
                        <div className="Voting_ratingLabel">{VOTING_VOTE_LABEL}</div>
                        <div className="Voting_ratingValue">{mark}</div>
                    </div>
                    <div className="Voting_vote">
                        {formatCounter(this.props.vote)}
                    </div>
                </div> */}
                <div className={styles.footer}>
                    {/* <div className="Voting_chart">
                        <Chart
                            options={options}
                            series={[percent]}
                            type="radialBar" // line, area, bar, pie, donut, scatter, bubble, heatmap, radialBar
                            width={265}
                            height={265}
                        />
                    </div> */}
                    <div
                        className={classNameButtonLike}
                        onClick={this.handleLikeClick}
                    />
                    <div className={styles.rating}>
                        <div className={styles.ratingLabel}>{VOTING_VOTE_LABEL}</div>
                        <div className={styles.ratingValue}>{mark}</div>
                    </div>
                    {/* {VOTING_TOTAL_LABEL} */}
                    <div
                        className={classNameButtonDislike}
                        onClick={this.handleDislikeClick}
                    />
                </div>
            </div>
        )
    }
}
